// This component houses the following
// 	- Dropzones for table fields
// 	- Graph section
// 	- Chart types / Controls selection menu

import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';

import './dataViewerMiddle.css';
// import chartControlIcon from "../../assets/chart-control-icon.svg";
// import settingsIcon from "../../assets/charts_theme_settings_icon.svg";

import { Dispatch } from 'redux';
import { DataViewerMiddleProps, DataViewerMiddleStateProps } from './DataViewerMiddleInterfaces';
import { setSelectedControlMenu } from '../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import ChartTypes from '../ChartOptions/ChartTypes';
import ChartAxes from '../ChartAxes/ChartAxes';
import GraphArea from '../GraphArea/GraphArea';
import ChartControlObjects from '../ChartOptions/ChartControlObjects';

import ChartFilterGroupsContainer from '../ChartFilterGroup/groupsContainer/ChartFilterGroupsContainer';
import { AlertColor, IconButton, Tooltip } from '@mui/material';
import DynamicMeasureWindow from './DynamicMeasureWindow';
import {
  setSelectedTabIdInDynamicMeasureState,
  setSelectedTileIdInDynamicMeasureState,
  setSelectedToEdit,
} from '../../redux/DynamicMeasures/DynamicMeasuresActions';
import { changeChartOptionSelected } from '../../redux/ChartPoperties/ChartPropertiesActions';
import { NotificationDialog } from '../CommonFunctions/DialogComponents';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CalculationCanvas from '../Calculations/CalculationCanvas/CalculationCanvas';
import CalculationRightPanel from '../Calculations/CalculationControlPanel/CalculationControlPanel';
import { fontSize } from '../..';
import { chartTypes } from '../ChartOptions/ChartTypeComponents/chartTypes';
import ParameterCanvas from '../Parameters/ParameterCanvas';
import ParameterContainer from '../Parameters/ParameterContainer';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { checkIfMissingColumn } from '../CommonFunctions/CommonFunctions';
import { WarningAmber } from '@mui/icons-material';
import { ReactFlowProvider } from '@xyflow/react';

const DataViewerMiddle = ({
  // props
  tabId,
  tileId,
  reportFilterMenu,
  setReportFilterMenu,
  parameterMenu,
  setParameterMenu,
  mapJSON,
  setMapJSON,
  setLoading,

  // state
  tabTileProps,
  chartProp,
  calculations,
  chartControls,

  parameters,
  enableOverrideForExtraMeasureUID,

  // dispatch
  setMenu,

  setSelectedTileIdForDM,
  setSelectedTabIdForDM,
}: DataViewerMiddleProps & any) => {
  var propKey: string = `${tabId}.${tileId}`;
  // var tabId = tabTileProps.selectedTabId;
  // var tileId = tabTileProps.selectedTileId;

  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [testMessage, setTestMessage] = useState<string>('');
  const [severity, setSeverity] = useState<AlertColor>('success');
  const selectedChart = chartProp.properties[propKey].chartType;
  const selectedChartData = chartTypes.find((chart) => chart.name === selectedChart);

  const showParameter = useMemo(
    () => parameters.savedParameters.find((parameter: any) => parameter.showParameter),
    [parameters.savedParameters],
  );
  const currentCalculationSession = useMemo(
    () => calculations.properties[propKey]?.currentCalculationSession,
    [calculations.properties[propKey]?.currentCalculationSession],
  );
  const currentParameterSession = useMemo(
    () => parameters.properties[propKey]?.parameterSession,
    [parameters.properties[propKey]?.parameterSession],
  );

  const enableOverrideForUID = useMemo(
    () => chartProp.properties[propKey]?.enableOverrideForUID,
    [chartProp.properties[propKey]?.enableOverrideForUID],
  );

  const MinimizeComponent = () => {
    return (
      <Tooltip
        title="Hide"
        slotProps={{
          tooltip: {
            sx: {
              fontSize: '12px',
            },
          },
        }}
      >
        <KeyboardArrowUpIcon
          sx={{
            fontSize: '18px',
            float: 'right',
            marginTop: '2px',
            // marginRight: "1rem",
          }}
          onClick={() => setMenu('')}
        />
      </Tooltip>
    );
  };

  const HideSideBarButton = () => {
    return (
      <div
        style={{
          bottom: '8px',
          width: '100%',
          textAlign: 'start',
          borderLeft: '2px solid rgba(224, 224, 224, 1)',
        }}
      >
        <Tooltip
          title="Hide Sidebar"
          slotProps={{
            tooltip: {
              sx: { fontSize: '12px' },
            },
          }}
        >
          <IconButton onClick={() => setMenu('')} sx={{ color: '#404040' }}>
            <KeyboardArrowRightIcon fontSize="large" />
          </IconButton>
        </Tooltip>
      </div>
    );
  };

  const selectedControlMenu = useMemo(
    () => tabTileProps.selectedControlMenu,
    [tabTileProps.selectedControlMenu],
  );
  const tooltipFormats = chartControls.properties[propKey].formatOptions?.tooltipFormats;
  const [missingExtraMeasureField, setMissingExtraMeasureField] = useState<boolean>(false);
  useEffect(() => {
    (async () => {
      // console.log(tooltipFormats);
      if (tooltipFormats.extraMeasureField[0]?.fields.length > 0) {
        const promises = tooltipFormats.extraMeasureField[0]?.fields.map(async (field: any) => {
          const res = await checkIfMissingColumn(
            field,
            chartProp.properties[propKey]?.selectedDs,
            tabTileProps.tablesForSelectedDataSets[chartProp.properties[propKey]?.selectedDs.id],
            (field as any).originalDataSetId !== chartProp.properties[propKey]?.selectedDs.id,
          );
          // console.log(field);
          // console.log(res);
          const showWarning =
            (field as any).originalDataSetId !== chartProp.properties[propKey]?.selectedDs.id
              ? Boolean(!res.newTableId)
              : Boolean(res.isMissing);
          // console.log(showWarning);
          return showWarning;
        });
        const results = await Promise.all(promises);
        // console.log(results);
        const anyMissing = results.some(Boolean);
        // console.log(anyMissing);
        setMissingExtraMeasureField(anyMissing);
      } else setMissingExtraMeasureField(false);
    })();
  }, [
    chartControls.properties[propKey].chartErrorDetails,
    tooltipFormats.extraMeasureField[0]?.fields.length,
    chartProp.properties[propKey].oldSelectedDs?.id,
    chartProp.properties[propKey]?.selectedDs.id,
  ]);
  // console.log(missingExtraMeasureField);

  const controlDisplayed = useMemo(() => {
    switch (selectedControlMenu) {
      case 'Charts':
        return (
          <div className="rightColumnControlsAndFilters">
            <div
              style={{
                color: ' #404040',
                fontWeight: '600',
                // padding: "0.5rem 0 0 0.82rem",
                paddingTop: '0.5rem',
                paddingLeft: '0.65rem',
                textAlign: 'start',
                fontSize: fontSize.large,
                marginRight: '1rem',
              }}
            >
              Charts
              <MinimizeComponent />
            </div>
            <ChartTypes propKey={propKey} />
          </div>
        );

      case 'Chart controls':
        return (
          <div className="rightColumnControlsAndFilters">
            <div
              style={{
                color: ' #404040',
                fontWeight: '600',
                padding: '0.5rem 0 0 0.5rem',
                textAlign: 'start',
                fontSize: fontSize.large,
                marginBottom: '0.19rem',
                scrollbarGutter: 'stable both-edges',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                }}
              >
                Charts Controls
                {selectedChartData ? (
                  <>
                    <img
                      src={selectedChartData.icon}
                      alt={selectedChartData.name}
                      title={selectedChartData.value}
                      className="selected-chart-icon"
                      // style={{ paddingRight: '2px' }}
                    />
                  </>
                ) : (
                  <p>No icon available for the selected chart</p>
                )}
                {missingExtraMeasureField &&
                  chartProp.properties[propKey]?.chartType !== 'crossTab' && (
                    <Tooltip arrow placement="top" title={'The chart has missing tooltip fields'}>
                      <WarningAmber
                        style={{ color: '#850000ff', fontSize: fontSize.large, marginRight: '4px' }}
                      />
                    </Tooltip>
                  )}
                <div
                  style={{
                    paddingLeft: missingExtraMeasureField ? '2.8rem' : '5.01rem',
                    marginRight: '0',
                  }}
                >
                  <MinimizeComponent />
                </div>
              </div>
            </div>
            <ChartControlObjects />
          </div>
        );

      case 'Report Filters':
        return (
          <div className="rightColumnControlsAndFilters">
            {Boolean(showParameter) && (
              <ParameterContainer
                parameterMenu={parameterMenu}
                setParameterMenu={setParameterMenu}
                isTile={!!tileId}
              />
            )}
            <ChartFilterGroupsContainer
              propKey={propKey}
              fromDashboard={false}
              reportFilterMenu={reportFilterMenu}
              setReportFilterMenu={setReportFilterMenu}
            ></ChartFilterGroupsContainer>
          </div>
        );
      default:
        return null;
    }
  }, [selectedControlMenu, tabId, tileId, showParameter, missingExtraMeasureField]);

  useEffect(() => {
    setSelectedTileIdForDM(tileId);
    setSelectedTabIdForDM(tabId);
  }, [tileId, tabId]);

  return (
    <>
      <div className="dataViewerMiddle" style={{ height: '300px' }}>
        {selectedChart === 'richText' ? (
          <>
            <GraphArea setMapJSON={setMapJSON} setLoading={setLoading} />
            <DynamicMeasureWindow />
          </>
        ) : (
          <ReactFlowProvider>
            <ChartAxes tabId={tabId} tileId={tileId} uID="" mapJSON={mapJSON} />
            {enableOverrideForUID !== null &&
            enableOverrideForUID !== undefined &&
            enableOverrideForUID !== '' ? (
              <>
                {!currentCalculationSession && (
                  <ChartAxes
                    tabId={tabId}
                    tileId={tileId}
                    uID={enableOverrideForUID}
                    mapJSON={mapJSON}
                  />
                )}
              </>
            ) : null}
            {currentCalculationSession ? (
              <CalculationCanvas propKey={propKey} />
            ) : currentParameterSession ? (
              <ParameterCanvas />
            ) : (
              <GraphArea setMapJSON={setMapJSON} setLoading={setLoading} />
            )}

            {enableOverrideForExtraMeasureUID !== null &&
            enableOverrideForExtraMeasureUID !== undefined &&
            enableOverrideForExtraMeasureUID !== '' ? (
              <>
                {!calculations.properties[propKey]?.currentCalculationSession && (
                  <ChartAxes
                    tabId={tabId}
                    tileId={tileId}
                    uID={enableOverrideForExtraMeasureUID}
                    mapJSON={mapJSON}
                    isExtraMeasure={true}
                  />
                )}
              </>
            ) : null}

            {currentCalculationSession || currentParameterSession ? null : (
              <div
                style={{
                  display: selectedControlMenu !== '' ? 'flex' : 'none',
                  flexDirection: 'column',
                }}
              >
                <div
                  className="rightColumn"
                  style={{
                    width: '15.625rem',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    ...(selectedControlMenu === '' ? { display: 'none' } : {}),
                  }}
                >
                  {controlDisplayed}
                </div>
                {selectedControlMenu === 'Charts' && <HideSideBarButton />}
              </div>
            )}
          </ReactFlowProvider>
        )}
        <NotificationDialog openAlert={openAlert} severity={severity} testMessage={testMessage} />
      </div>
    </>
  );
};

const mapStateToProps = (state: DataViewerMiddleStateProps & any, ownProps: any) => {
  const propKey = `${ownProps.tabId}.${ownProps.tileId}`;
  return {
    chartProp: state.chartProperties,
    tabTileProps: state.tabTileProps,
    dynamicMeasureState: state.dynamicMeasuresState,
    chartControls: state.chartControls,
    calculations: state.calculations,
    parameters: state.parameters,
    enableOverrideForExtraMeasureUID:
      state.chartControls.properties[propKey]?.formatOptions?.tooltipFormats
        ?.enableOverrideForExtraMeasureUID,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    setMenu: (menu: string) => dispatch(setSelectedControlMenu(menu)),

    changeChartOption: (propKey: string, chartValue: any) =>
      dispatch(changeChartOptionSelected(propKey, chartValue)),

    setSelectedTileIdForDM: (tileId: number) =>
      dispatch(setSelectedTileIdInDynamicMeasureState(tileId)),
    setSelectedTabIdForDM: (tabId: number) =>
      dispatch(setSelectedTabIdInDynamicMeasureState(tabId)),
    setSelectedToEdit: (tabId: number, tileId: number, dmId: number, value: boolean) =>
      dispatch(setSelectedToEdit(tabId, tileId, dmId, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataViewerMiddle);
